import React, { useEffect, useState } from "react";
import ServiceCard from "../Elements/ServiceCard";

export default function ServicesVMobile() {
  const [isInView, setIsInView] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold: 0.05 }
    );

    const container = document.querySelector(".servicesContainer");
    if (container) observer.observe(container);

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: "fa-solid fa-laptop",
      title: "Subvention",
      subtitle: "Nos formations sont 100% subventionnées par l'OPCO",
      animation: "Comptability.json",
      frontColor: "linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))",
      backColor: "linear-gradient(135deg,rgb(43, 61, 226),rgb(112, 218, 213))",
    },
    {
      icon: "fa-solid fa-language",
      title: "Efficacité",
      subtitle:
        "Nos formateurs sont des professionnels reconnus dans leurs domaines",
      animation: "Langue.json",
      frontColor: "linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))",
      backColor: "linear-gradient(135deg,rgb(43, 226, 211),rgb(112, 218, 117))",
    },
    {
      icon: "fa-solid fa-user",
      title: "Adaptabilité",
      subtitle:
        "Nos formations sont flexibles et sont dispensées en présentiel ou en distanciel selon vos préférences",
      animation: "design.json",
      frontColor: "linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))",
      backColor: "linear-gradient(135deg,rgb(49, 226, 43),rgb(169, 218, 112))",
    },
    {
      icon: "fa-solid fa-users-cog",
      title: "Qualité Garantie",
      subtitle:
        "Nous avons aidé plus de 500 entreprises à se former et à se développer",
      animation: "Professionals.json",
      frontColor: "linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))",
      backColor:
        "linear-gradient(135deg, rgb(167, 63, 181), rgb(243, 33, 198))",
    },
  ];

  return (
    <section className="w-full bg-white py-10">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold">Pourquoi Nous Choisir</h1>
        </div>
        <div className="flex flex-wrap justify-center gap-6 servicesContainer">
          {services.map((s, idx) => (
            <div key={idx} className="w-full sm:w-[45%] md:w-[22%] py-0">
              <ServiceCard
                icon={s.icon}
                title={s.title}
                subtitle={s.subtitle}
                animationPath={
                  isInView
                    ? require(`../../assets/animation/${s.animation}`)
                    : null
                }
                frontColor={s.frontColor}
                backColor={s.backColor}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
